// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".batch_page .el-form-item-search {\n  width: 400px;\n}\n.batch_page .el-form-item-search .el-form-item__content .el-input {\n    width: 120px;\n}\n.batch_page .el-form-item-search .el-form-item__content .el-input__inner {\n    width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
